import React, {useContext, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {TranslateContext} from "../../../context/TranslateContext";
import {aggiornaDocumentoKpiApi} from "../services/DocumentiServices";
import UploadDocumentiKpiView from "./UploadDocumentiKpiView";

export default function UploadDocumentiKpiController() {
    const {idKpi, idTipoImport} = useParams();

    const [files, setFiles] = useState([]);
    const [descrizione, setDescrizione] = useState('');
    const [idDocumento, setIdDocumento] = useState();
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');

    const {translate} = useContext(TranslateContext);
    const history = useHistory();

    const url = process.env.REACT_APP_API_ENDPOINT + "/api/sost/kpi/" + idKpi + '/documento/';

    async function salvaDocumento() {
        const documento = {
            descrizione: descrizione,
            id_tipo_imp_dati: idTipoImport
        };
        const response = await aggiornaDocumentoKpiApi(idKpi, idDocumento, documento);
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: salvaDocumento,
            disabled: !idDocumento
        }
    ];

    function handlePostUpload(idDocumento) {
        setIdDocumento(idDocumento);
    }

    function handleDeleteDocumento() {
        setIdDocumento(null);
        setFiles([])
    }

    return (
        <UploadDocumentiKpiView
            setShow={setShow}
            url={url}
            show={show}
            setDescrizione={setDescrizione}
            modalMsg={modalMsg}
            idTipoImport={idTipoImport}
            descrizione={descrizione}
            files={files}
            setFiles={setFiles}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            handlePostUpload={handlePostUpload}
            handleDeleteDocumento={handleDeleteDocumento}
        />
    )
}